import { FC, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

// Components
import Button from "./Button";

import config from "../../config";

// Icons
import { ReactComponent as HomeIcon } from "../../icons/HomeIcon.svg";
import { ReactComponent as HomeDarkIcon } from "../../icons/HomeIconFilled.svg";
import { ReactComponent as FoodEntrepreneurIcon } from "../../icons/FoodEntrepreneur.svg";
import { ReactComponent as FoodEntrepreneurDarkIcon } from "../../icons/FoodEntrepreneurDark.svg";
import { ReactComponent as ResourceProviders } from "../../icons/KitchenOperator.svg";
import { ReactComponent as ResourceProvidersDarkIcon } from "../../icons/KitchenOperatorDark.svg";
import { ReactComponent as NavDoucmentationIcon } from "../../icons/NavDocumentationIcon.svg";
import { ReactComponent as NavTutorialsIcon } from "../../icons/NavTutorialsIcon.svg";
import { ReactComponent as ArrowDownIcon } from "../../icons/FaqDownArrow.svg";
import { ReactComponent as ArrowUpIcon } from "../../icons/FaqUpArrow.svg";

type NavbarMobileMenuProps = {
  isMobileNavbarMenuOpen: boolean;
  setIsMobileNavbarMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const NavbarMobileMenu: FC<NavbarMobileMenuProps> = ({
  isMobileNavbarMenuOpen,
  setIsMobileNavbarMenuOpen,
}) => {
  // Navigation Links
  const navigate = useNavigate();
  const location = useLocation();
  const currentLocation = location.pathname;

  const goToHome = () => {
    navigate("/");
    if (currentLocation !== "/") setIsMobileNavbarMenuOpen(false);
  };

  const goToFoodEntrepreneurs = () => {
    navigate("/food-entrepreneurs");
    if (currentLocation !== "/food-entrepreneurs")
      setIsMobileNavbarMenuOpen(false);
  };

  const goToResourceProviders = () => {
    navigate("/resource-providers");
    if (currentLocation !== "/resource-providers")
      setIsMobileNavbarMenuOpen(false);
  };

  // Dropdown Statea
  const [foodDropDown, setFoodDropDown] = useState(false);
  const [resourceDropDown, setResourceDropDown] = useState(false);

  const toggleFoodDropDown = () => {
    if (currentLocation === "/food-entrepreneurs") {
      setFoodDropDown((prev) => !prev);
    }
  };

  const toggleResourceDropDown = () => {
    if (currentLocation === "/resource-providers") {
      setResourceDropDown((prev) => !prev);
    }
  };

  // Handle Buttons
  function handleResourcePantryBtn() {
    var webUrl = config?.webUrl;
    window.open(webUrl, "_blank");

    // setIsMobileNavbarMenuOpen(false);
  }

  // function handleBookDemoBtn() {
  //   const demoUrl =
  //     "https://calendly.com/homecook/homecook-resource-provider-demo";
  //   window.open(demoUrl, "_blank");

  //   // setIsMobileNavbarMenuOpen(false);
  // }

  const goToComplianceChecklist = () => {
    navigate("/compliance/checklist");
    setIsMobileNavbarMenuOpen(false);
  };

  return (
    <>
      {isMobileNavbarMenuOpen && (
        <div className="text-primaryDark-0 mt-[90px] h-[calc(100vh-90px)] relative">
          {/* Navigation Links */}
          <div className="flex flex-col gap-[16px] absolute top-0 left-0 w-full px-[30px] py-[20px]">
            {/* Home Link */}
            <div
              className="flex items-center w-full h-[40px] px-[10px] py-[4px] gap-[8px] cursor-pointer"
              onClick={goToHome}
            >
              {currentLocation === "/" ? (
                <HomeDarkIcon className="text-primaryDark-0" />
              ) : (
                <HomeIcon className="text-text-300" />
              )}

              <h6
                className={`font-raleway text-[16px] ${currentLocation === "/" ? "text-primaryDark-0 font-semibold" : "text-text-300"}`}
              >
                Home
              </h6>
            </div>

            {/* Food Entrepreneurs Link */}
            <div
              className="flex items-center justify-between w-full h-[40px] pr-[10px] gap-[8px] cursor-pointer"
              onClick={goToFoodEntrepreneurs}
            >
              <div className="flex items-center gap-[8px] w-[calc(100%-20px)] pl-[10px] py-[4px] h-full">
                {currentLocation === "/food-entrepreneurs" ? (
                  <FoodEntrepreneurDarkIcon className="text-primaryDark-0" />
                ) : (
                  <FoodEntrepreneurIcon className="text-text-300" />
                )}

                <h6
                  className={`font-raleway text-[16px] ${currentLocation === "/food-entrepreneurs" ? "text-primaryDark-0 font-semibold" : "text-text-300"}`}
                >
                  Food Entrepreneurs
                </h6>
              </div>

              <div onClick={toggleFoodDropDown}>
                {currentLocation === "/food-entrepreneurs" && foodDropDown ? (
                  <ArrowUpIcon className="w-[20px] h-[20px]" />
                ) : (
                  <ArrowDownIcon className="w-[20px] h-[20px]" />
                )}
              </div>
            </div>

            {currentLocation === "/food-entrepreneurs" && foodDropDown && (
              <div className="rounded-b-[8px] flex flex-col gap-[8px] px-[10px]">
                <a
                  href="#food-how"
                  onClick={() => setIsMobileNavbarMenuOpen(false)}
                  className="w-full flex items-center gap-[8px] px-[10px] py-[15px] text-[14px] text-text-300"
                >
                  <NavDoucmentationIcon className="w-[20px] h-[20px]" />
                  How It Works
                </a>

                <a
                  href="#food-how-box"
                  onClick={() => setIsMobileNavbarMenuOpen(false)}
                  className="w-full flex items-center gap-[8px] px-[10px] py-[15px] text-[14px] text-text-300"
                >
                  <NavTutorialsIcon className="w-[20px] h-[20px]" />
                  View Tutorials
                </a>
              </div>
            )}

            {/* Resource Providers Link */}
            <div
              className="flex items-center justify-between w-full h-[40px] pr-[10px] gap-[8px] cursor-pointer"
              onClick={goToResourceProviders}
            >
              <div className="flex items-center gap-[8px] w-[calc(100%-20px)] pl-[10px] py-[4px] h-full">
                {currentLocation === "/resource-providers" ? (
                  <ResourceProvidersDarkIcon className="text-primaryDark-0" />
                ) : (
                  <ResourceProviders className="text-text-300" />
                )}

                <h6
                  className={`font-raleway text-[16px] ${currentLocation === "/resource-providers" ? "text-primaryDark-0 font-semibold" : "text-text-300"}`}
                >
                  Resource Providers
                </h6>
              </div>

              <div onClick={toggleResourceDropDown}>
                {currentLocation === "/resource-providers" &&
                resourceDropDown ? (
                  <ArrowUpIcon className="w-[20px] h-[20px]" />
                ) : (
                  <ArrowDownIcon className="w-[20px] h-[20px]" />
                )}
              </div>
            </div>

            {currentLocation === "/resource-providers" && resourceDropDown && (
              <div className="rounded-b-[8px] flex flex-col gap-[8px] px-[10px]">
                <a
                  href="#resource-how"
                  onClick={() => setIsMobileNavbarMenuOpen(false)}
                  className="w-full flex items-center gap-[8px] px-[10px] py-[15px] text-[14px] text-text-300"
                >
                  <NavDoucmentationIcon className="w-[20px] h-[20px]" />
                  How It Works
                </a>

                <a
                  href="#resource-how-box"
                  onClick={() => setIsMobileNavbarMenuOpen(false)}
                  className="w-full flex items-center gap-[8px] px-[10px] py-[15px] text-[14px] text-text-300"
                >
                  <NavTutorialsIcon className="w-[20px] h-[20px]" />
                  View Tutorials
                </a>
              </div>
            )}
          </div>

          {/* Buttons */}
          <div className="flex flex-col gap-[16px] absolute bottom-0 left-0 w-full p-[20px]">
            <Button
              label={"View Resource Pantry"}
              variant="primary"
              onClick={handleResourcePantryBtn}
            />
            <Button
              label={"Check Readiness"}
              variant="secondary"
              onClick={goToComplianceChecklist}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default NavbarMobileMenu;
